module.exports = __webpack_public_path__ + "img/order-confirmed.252acd24.svg";